export default "/fonts/poppins-v9-latin-500.woff?9cce51605ae9e0a9357a6e0c822f38c6";